module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "size": "tiny",
      "top": "60px",
      "modal": false,
      "lock-scroll": false,
      "modal-append-to-body": false,
      "close-on-click-modal": false,
      "show-close": false,
      "title": "新增磁贴"
    },
    on: {
      "close": _vm.clear
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "磁贴名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务地址",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.form.url = $$v
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "板块分组",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择分组板块"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.form.region = $$v
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "租户管理",
      "value": "zuhuguanli"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "组织管理",
      "value": "zuzhiguanli"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择图标",
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.isActive) ? _c('img', {
    staticClass: "formImg",
    attrs: {
      "src": _vm.form.img
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openSelectImg
    }
  }, [_vm._v("选择图标")]) : _vm._e(), _vm._v(" "), (_vm.isActive) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openSelectImg
    }
  }, [_vm._v("重新选择")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.formSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny",
      "top": "60px",
      "title": "选择图标",
      "modal": false,
      "lock-scroll": false,
      "modal-append-to-body": false,
      "close-on-click-modal": false,
      "show-close": false
    },
    model: {
      value: (_vm.imgDialog),
      callback: function($$v) {
        _vm.imgDialog = $$v
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-row', _vm._l((_vm.imgList), function(img, index) {
    return _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', [_c('img', {
      staticClass: "formImg",
      attrs: {
        "src": img.src
      },
      on: {
        "click": function($event) {
          _vm.selectImg(index)
        }
      }
    })])], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e72a06b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sideDialog.vue
// module id = 511
// module chunks = 1